import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ChartUserPayload } from '../models/chart-data.model';

interface ProductionSummaryChartData
{ name: string; y: number; z: number; realY?: number | null; }
interface ProductionSummaryDebtChartData
{ name: string; y: number; z: number; realY?: number | null; }
interface PipeLineForecastChartData
{ name: string; y: number; z: number }
interface PipeTrendsChartData
{ name: string; data: number[] }
interface TopLendersChartData
{ Id: number; LoanAmount: number; CompanyName: string }
@Injectable({ providedIn: 'root' })
export class ChartService {

  public constructor(private http: HttpClient) {}

  public getPipelineForecastChartData(teamId?: number): Observable<PipeLineForecastChartData[]> {
    return this.http.get<PipeLineForecastChartData[]>(`/api/is/ChartApi/GetForecastPipeline?teamId=${teamId}`);
  }

  public getProductionSummaryChartData(teamId?: number): Observable<ProductionSummaryChartData[]> {
    return this.http.get<ProductionSummaryChartData[]>(`/api/is/ChartApi/GetProductionSummaryChart?teamId=${teamId}`);
  }

  public getPipelineTrendsChartData(teamId?: number): Observable<PipeTrendsChartData[]> {
    return this.http.get<PipeTrendsChartData[]>(`/api/is/ChartApi/GetPipelineTrendsChart?teamId=${teamId}`);
  }

  public getProductionSummaryDebtChartData(chartUserPayload: ChartUserPayload):
    Observable<ProductionSummaryDebtChartData[]> {
    return this.http.post<ProductionSummaryDebtChartData[]>(`/api/debt/ChartApi/GetProductionSummaryChartDebt`, chartUserPayload);
  }

  public getTopLendersChartData(type = 1): Observable<TopLendersChartData[]> {
    return this.http.get<TopLendersChartData[]>(`/api/debt/ChartApi/GetTopLenders?type=${type}`);
  }

  public getLogData(data: ProductionSummaryChartData[] | ProductionSummaryDebtChartData[]) {
    return data.map(function (value) {
      return {
        name: value.name,
        y: Math.log(value.y) / Math.LN10,
        realY: value.y,
        z: value.z
      };
    });
  }
}
